var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BProgress',{attrs:{"height":"2rem","value":_vm.value,"max":100,"precision":2,"show-value":"","show-progress":"","animated":""}},[_c('BProgressBar',{attrs:{"value":_vm.value}},[_c('span',[_vm._v("Výkon: "),_c('strong',[_vm._v(_vm._s(this.settled)+" / "+_vm._s(this.total)+", tj. "+_vm._s(_vm.value.toFixed(0))+" %")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }